/* @flow */

import {useMutation} from '@apollo/react-hooks';

import type {
    SelectCreateAccount as SelectCreateAccountMutation,
    SelectCreateAccountVariables as SelectCreateAccountMutationVariables,
    AccountCreateInput,
} from 'nutshell-graphql-types';

import CREATE_ACCOUNT from '../mutations/create-account.graphql';
import GET_ACCOUNTS from '../queries/get-accounts-search-results.graphql';

export function useCreateAccount(): (input: AccountCreateInput, searchTerm: ?string) => Promise<*> {
    const [createAccount] = useMutation<
        SelectCreateAccountMutation,
        SelectCreateAccountMutationVariables
    >(CREATE_ACCOUNT);

    return (input: AccountCreateInput, searchTerm: ?string) => {
        return createAccount({
            variables: {account: input},
            update: (proxy, mutationResults) => {
                const newAccount =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.accountCreate &&
                    mutationResults.data.accountCreate.account;

                const cacheResult = proxy.readQuery({
                    query: GET_ACCOUNTS,
                    variables: {query: searchTerm, type: 'ACCOUNT'},
                });

                if (cacheResult && newAccount) {
                    proxy.writeQuery({
                        query: GET_ACCOUNTS,
                        variables: {query: searchTerm, type: 'ACCOUNT'},
                        data: {
                            ...cacheResult,
                            search: {
                                __typename: 'SearchResultItemConnection',
                                quickResults: cacheResult.search.quickResults,
                                accountResults: [
                                    ...cacheResult.search.quickResults.accountResults,
                                    newAccount,
                                ],
                            },
                        },
                    });
                }
            },
        });
    };
}
